import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Error.module.scss';
import { FaIcon } from 'components/ui';
import { t, apiErrorTransform } from 'utils';

export interface IError extends HTMLAttributes<HTMLDivElement> {
  isError?: boolean | string;
  apiError?: any;
  defaultError?: string;
}

const Error: FC<IError> = (props) => {
  const { apiError, defaultError, isError, className, children } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.active]: isError,
    'd-none': !isError,
  });
  const errorKey = apiErrorTransform(apiError, defaultError);

  return (
    <div className={rootClassName}>
      <FaIcon className={styles.icon} icon='exclamation-triangle' />
      <span>{apiError ? t(errorKey) : children}</span>
    </div>
  );
};

export default Error;
